import { Column } from "@tanstack/react-table"
import { mergeCategoryOptions, useOrgCategoryNames } from "@/deduction/category_options.ts"
import { ColumnHeader } from "./column_header"

interface CategoryFilterHeaderProps<TData> {
  column: Column<TData, unknown>
  /** Called with the chosen category name, or "all" to clear the filter. */
  onSelectChoice: (choice: string) => void
  className?: string
}

/**
 * Category column header whose filter dropdown lists the org's actual categories (from
 * GET /categories) instead of a hardcoded canonical list, so renamed/custom categories are
 * selectable and renamed-away names never appear.
 */
export function CategoryFilterHeader<TData>({ column, onSelectChoice, className }: CategoryFilterHeaderProps<TData>) {
  const orgCategoryNames = useOrgCategoryNames()
  const choices = mergeCategoryOptions(orgCategoryNames).filter(c => c !== "Early Pay")
  return (
    <ColumnHeader
      // @ts-ignore — ColumnHeader is generic over the table's row type
      column={column}
      title="Category"
      className={className}
      choices={choices}
      onSelectChoice={onSelectChoice}
    />
  )
}
